export enum ExportsEndpoint {
  Base = '/exports',
  Files = '/files',
}
